module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv2-9b439b4f968ea58ce01f0d22efdf3f16.jpg";